import apiClient from "../../axios/apiClient";


export const getVehicleList =
  (token, limit = 10, page = 1, search = "", sort = "desc") =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_VEHICLELIST_PENDING" });

      const response = await apiClient.get(
        `/api/v1/vehicles`,
        {
          params: {
            limit: limit,
            page: page,
            search: search,
            sort: sort,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_VEHICLELIST_FULFILLED",
        payload: response.data?.data,
        vehicleCount: response.data?.count,
        permissions: response.data?.permissions,
      });
    } catch (error) {
      dispatch({
        type: "GET_VEHICLELIST_REJECTED",
        payload: error.response,
      });
    }
  };


  export const saveVehicleData = (token, data) => async (dispatch) => {
    try {
      dispatch({ type: "ADD_VEHICLE_PENDING" });
  
      const response = await apiClient.post(
        `/api/v1/vehicles`,
        data, // Data payload should be the second argument
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({ type: "ADD_VEHICLE_FULFILLED", payload: response.data });
    } catch (error) {
      dispatch({ type: "ADD_VEHICLE_REJECTED", payload: error.response });
    }
  };
  

  export const getVehicleListById =(token,id) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_VEHICLELISTBYID_PENDING" });

      const response = await apiClient.get(
        `/api/v1/vehicles/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_VEHICLELISTBYID_FULFILLED",
        payload: response.data?.data,
        vehicleCount: response.data?.count,
      });
    } catch (error) {
      dispatch({
        type: "GET_VEHICLELISTBYID_REJECTED",
        payload: error.response,
      });
    }
  };


export const updateVehicleData = (token, data, id) => async (dispatch) => {
  try {
    dispatch({ type: "UPDATE_VEHICLE_PENDING" });

    const response = await apiClient.put(
      `/api/v1/vehicles/${id}`, // Endpoint URL with vehicle ID
      data, // Data payload
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_VEHICLE_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_VEHICLE_REJECTED", payload: error.response });
  }
};


export const updateVehicleStatusData = (token, id, status) => async (dispatch) => {
  try {
    dispatch({ type: "UPDATE_VEHICLE_STATUS_PENDING" });
    const data={
      "status":status
    }
    const response = await apiClient.post(
      `/api/v1/vehicles/${id}/`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_VEHICLE_STATUS_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_VEHICLE_STATUS_REJECTED", payload: error.response });
  }
};


export const deleteVehicleData = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: "DELETE_VEHICLE_PENDING" });

    const response = await apiClient.delete(
      `/api/v1/vehicles/${id}`, // Endpoint URL with vehicle ID
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "DELETE_VEHICLE_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "DELETE_VEHICLE_REJECTED", payload: error.response });
  }
};
